import { module } from 'stereomodularjs';
// import LocomotiveScroll from 'locomotive-scroll';
// import Rellax from 'rellax';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // this.locomotiveScroll = new LocomotiveScroll({
        //     lenisOptions: {
        //         smoothWheel: true, // Set to false to disable smoothScroll, but keep is-inview class triggering
        //         smoothTouch: false, // Disable on mobile devices
        //     },
        // });

        // data-scroll-event-progress Example
        // window.addEventListener('progressEvent', (e) => {
        //     const { target, progress } = e.detail;
        //     const percent = progress * 100;
        //     const percentRounded = Math.round(progress * 100);
        //     const progressEl = document.querySelector('.js-progress');
        //     const progressBarEl = document.querySelector('.js-progress-bar');

        //     if (progress && progressEl && progressBarEl) {
        //         progressEl.innerHTML = percentRounded + '%';
        //         progressBarEl.style.cssText += `width: ${percent}%;`;
        //     }
        // });

        // this.rellax = new Rellax('[data-scroll]', { horizontal: true, breakpoints: [576, 768, 1024] });

        // this.observer = new IntersectionObserver((entries) => {
        //     entries.forEach(entry => {
        //         if (entry.isIntersecting) {

        //             // If follower
        //             if (entry.target.dataset.follower != undefined) {
        //                 if (entry.target.dataset.follower != '') {
        //                     // if follower is set -> go to follower
        //                     document.querySelector(entry.target.dataset.follower).classList.add('is-show');
        //                 } else {
        //                     // if follower is unset -> go to parent
        //                     entry.target.parentNode.classList.add('is-show');
        //                 }
        //             } else {
        //                 // Add Class
        //                 entry.target.classList.add('is-show');
        //             }

        //             // Enable toggle by addind data-toggle
        //             if (entry.target.dataset.toggle == undefined) {
        //                 this.observer.unobserve(entry.target);
        //                 return;
        //             }
        //         } else {
        //             // Remove class here
        //             if (entry.target.dataset.follower != undefined) {
        //                 if (entry.target.dataset.follower != '') {
        //                     // if follower is set -> go to follower
        //                     document.querySelector(entry.target.dataset.follower).classList.remove('is-show');
        //                 } else {
        //                     // if follower is unset -> go to parent
        //                     entry.target.parentNode.classList.remove('is-show');
        //                 }
        //             } else {
        //                 entry.target.classList.remove('is-show');
        //             }
        //         }
        //     });
        // }, { threshold: 0.25 });

        // this.el.querySelectorAll('.js-inview').forEach((el) => {
        //     this.observer.observe(el)
        // })
    }

    destroy() {
        super.destroy();
        // if (this.observer) {
        //     this.observer.disconnect();
        //     this.observer = null;
        // }
        // if (this.rellax) {
        //     this.rellax.destroy();
        //     this.rellax = null;
        // }
        // if (this.locomotiveScroll) {
        //     this.locomotiveScroll.destroy();
        //     this.locomotiveScroll = null;
        // }
        // window.removeEventListener('progressEvent', () => { });
    }
}